import React from 'react';
import styles from './style.module.css';
import IframeResize from "../../../../common/components/iframe-resize";

export default () => (
    <div className={styles.page}>
        <h1 className={'invisible'}>Pay Yourself First Calculator</h1>
        <iframe src="https://www.financialcalculators.net/librocu/pay-yourself-first/" title="Pay Yourself First Calculator" width="100%" scrolling="no" frameBorder="0"> </iframe>
        <IframeResize />
    </div>
);
